import {flowRight as compose} from 'lodash';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {Mutation} from 'react-apollo';
import {Col, Container, Row} from 'react-bootstrap';
import {withTranslation} from 'react-i18next';
import {PulseLoader} from 'react-spinners';
import Error from '../../../common/components/Error/Error';
import PopIn from '../../../common/components/PopIn';
import {
  CancelButton,
  Div,
  FileDiv,
  FileInput,
  FileLabel,
  FileNameDiv,
  FooterRow,
  GradientCol,
  Input,
  TitleButton,
} from '../../../common/components/StyledComp';
import Tooltip from '../../../common/components/Tooltip';
import {GRAPHQL_MUTATION_ADD_BRAND} from '../../../common/queries/brand';

const AddBrand = props => {
  const {t} = props;

  const [modalVisible, setModalVisible] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [newBrand, setNewBrand] = useState({name: '', file:null, extraFile:null});
  const [errorUpload] = useState(null);
  const [wrongFormat] = useState(false);
  const [fileName, setFileName] = useState('');
  const [extraFileName, setExtraFileName] = useState('');

  const onBrandAdded = addBrand => {
    addBrand().then(({data}) => {
      if (data.addBrand.name) {
        if (props.onBrandAdded) {
          props.onBrandAdded();
        }
        setModalVisible(false);
        setNewBrand({name: '', file:null, extraFile:null});
        setFileName('');
        setExtraFileName('');
      }
    });
  };

  return (
    <Mutation
      mutation={GRAPHQL_MUTATION_ADD_BRAND}
      variables={{input: newBrand}}
      onCompleted={() => {
        setNewBrand({name: '', file: null, extraFile:null});
        setFileName('');
        setExtraFileName('');
        setSubmitted(false);
      }}
      refetchQueries={['brands']}
    >
      {(addBrand, {error, loading}) => {
        return (
          <div>
            <TitleButton onClick={() => setModalVisible(true)} className="title-btn">
              {t('addBrand.title')}
            </TitleButton>

            <PopIn visible={modalVisible} setModalVisible={setModalVisible} title={t('addBrand.title')}>
              <Container>
                <form
                  onSubmit={e => {
                    e.preventDefault();
                    if (newBrand.name !== '' && newBrand.file !== '') {
                      onBrandAdded(addBrand);
                    }
                  }}
                >
                  <Row>
                    <Col xs={9} className="extended-col">
                      <Div className="attribute-name">{`${t('name')} : `}</Div>
                      <PulseLoader loading={loading} />
                      <Input
                        type="text"
                        placeholder={t('name')}
                        name="brand_name"
                        onChange={e => {
                          setNewBrand({...newBrand, name: e.target.value});
                          setSubmitted(false);
                        }}
                        empty={newBrand.name === '' && submitted}
                      />
                      <Tooltip show={newBrand.name === '' && submitted} color="red">
                        {t('addBrand.requiredField')}
                      </Tooltip>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={9}>
                      <Div className="attribute-name">{`${t('logo')} : `}</Div>
                      <FileLabel empty={newBrand.file === null && submitted}>
                        {' '}
                        <FileNameDiv>{fileName}</FileNameDiv>
                        <FileDiv>{t('browse')}</FileDiv>
                        <FileInput type="file" accept="image/*" onChange={event => {
                          const files = event.target.files;
                          setNewBrand({...newBrand, file: files[0]});
                          setFileName(files[0].name);
                        }} required />
                      </FileLabel>
                      <Tooltip show={newBrand.file === null && submitted} color="red">
                        {t('addBrand.requiredField')}
                      </Tooltip>
                      <Tooltip show={wrongFormat} color="red">
                        {t('addBrand.format') + wrongFormat}
                      </Tooltip>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={9}>
                      <Div className="attribute-name">{`${t('logoDriver')} : `}</Div>
                      <FileLabel empty={newBrand.extraFile === null && submitted}>
                        {' '}
                        <FileNameDiv>{extraFileName}</FileNameDiv>
                        <FileDiv>{t('browse')}</FileDiv>
                        <FileInput type="file" accept="image/*" onChange={event => {
                          const files = event.target.files;
                          setNewBrand({...newBrand, extraFile: files[0]});
                          setExtraFileName(files[0].name);
                        }}/>
                      </FileLabel>
                      <Tooltip show={wrongFormat} color="red">
                        {t('addBrand.format') + wrongFormat}
                      </Tooltip>
                    </Col>
                  </Row>
                  <FooterRow>
                    <GradientCol sm={{span: 6, offset: 3}}>
                      <Error error={errorUpload} />
                      <Error error={error} />
                      <div className="popin-buttons">
                        <TitleButton
                          type="submit"
                          disabled={loading}
                          onClick={() => {
                            setSubmitted(true);
                          }}
                        >
                          {t('addBrand.title')}
                        </TitleButton>
                        <CancelButton
                          onClick={() => {
                            setModalVisible(false);
                            setNewBrand({name: '', file: null, extraFile:null});
                            setFileName('');
                            setExtraFileName('');
                            setSubmitted(false);
                          }}
                          style={{marginTop: 0, width: 'auto'}}>
                          {t('cancel')}
                        </CancelButton>
                      </div>
                    </GradientCol>
                  </FooterRow>
                </form>
              </Container>
            </PopIn>
          </div>
        );
      }}
    </Mutation>
  );
};

AddBrand.propTypes = {
  t: PropTypes.func.isRequired,
  onBrandAdded: PropTypes.func,
};

export default compose(
  withTranslation('brand'),
)(AddBrand);
